import React from "react"
import axios from 'axios';
import { HorseResultTable } from './results/HorseResultTable.jsx';
import { NewHorseForm } from '../forms/NewHorseForm.jsx';
import I18n from 'i18n-js';
import '../translations.js';

export class HorseSearchForm extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      newForm: this.props.skipSearch,
      showTable: false,
      resultArray: []
    };
    this.searchExistingHorses = this.searchExistingHorses.bind(this);
    this.updateResultTable = this.updateResultTable.bind(this);
    this.showNewForm = this.showNewForm.bind(this);
  }

  searchExistingHorses(e) {
    e.preventDefault();
    axios.post('/api/v1/search/horse_search', {
      horse_name: this.horseName.value
      })
      .then(response => this.updateResultTable(response.data))
      .catch(error => this.setState({ errorMessage: 'Error...'}));
  }

  updateResultTable(data) {
    this.setState({ 
      showTable: true,
      resultArray: data.horses 
    });
  }

  showNewForm() {
    this.setState({ newForm: true });
  }

  render () {
    return (
      <div>
       {!this.state.newForm ?
          <div>
            <h2>{I18n.t("exhibitor.horse_search")}</h2>
            <div className="alert alert-danger">
              <p>IMPORTANT</p>
              <ul>
                <li>{I18n.t("horse.horse_already_in_system")}</li>
                <br/>
                <li>{I18n.t("horse.do_not_create_duplicate_profile")}</li>
              </ul>
            </div>
            <div className="row">
              <form onSubmit={this.searchExistingHorses}>
                <input type="text" placeholder={I18n.t("wizard.horse_name")} minLength="2" ref={input => this.horseName = input} />
                <button className="btn btn-info">{I18n.t("search")}</button>
                <p>{I18n.t("exhibitor.company_search_hint")}</p>
              </form>
              <div>
                {this.state.showTable ? 
                  <div>
                    <HorseResultTable results={this.state.resultArray} />
                    <br/>
                    <br/>
                    <div className="alert alert-danger">
                      <p>{I18n.t("important_all_caps")}</p>
                      <ul>
                        <li>{I18n.t("horse.submit_show_entries")}</li>
                        <br/>
                        <li>{I18n.t("horse.horse_moved_to_current_exhibitor")}</li>
                        <br/>
                        <li> {I18n.t("horse.click_button_to_create_horse")}</li>
                      </ul>
                    </div>
                    <br/>
                    <button className="btn btn-success" onClick={this.showNewForm}>{I18n.t("horse.create_new_horse")}</button>
                    <br/>
                  </div>
                  : undefined
                }
                <br/>
                <button className="btn btn-success" onClick={this.props.goBack}>{I18n.t("back_button_label")}</button>
              </div>
            </div>
          </div>
          :
          <NewHorseForm 
            createUserData={this.props.createUserData}
            type={this.props.type}
            horseData={this.props.horseData}
            usef={this.props.usef}
            ec={this.props.ec}
            fei={this.props.fei}
          />
        }
      </div>
    );
  }
}

